define('presentation/signup/viewModels/signupFreeTrialViewModel',[
        'i18next',
        'common/promises/promiseFactory',
        'plugins/router',
        'presentation/signup/common/signupNavigationManager'
    ],
    function() {
        return function() {
            const self = this;

            const PromiseFactoryConstructor = require('common/promises/promiseFactory');
            const _promiseFactory = new PromiseFactoryConstructor();
            const _i18n = require('i18next');

            const BENEFIT_KEYS = ["benefit1", "benefit2", "benefit3", "benefit4", "benefit5", "benefit6"];

            let _router = null;
            let _signupNavigationManager = null;
            let _isNavigating = false;

            self.isCompositionComplete = ko.observable(false);

            self.headingText = _i18n.t('signupFreeTrial:headingText');
            self.subtitleText = _i18n.t('signupFreeTrial:subtitleText');
            self.getStartedText = _i18n.t('signupFreeTrial:getStarted');
            self.benefits = BENEFIT_KEYS.map(key => _i18n.t(`signupFreeTrial:${key}`));

            // The affiliate parameter is read off the plans route and the package parameters are
            // applied by the plans view model, so dropping the query string here loses attribution
            // and the deep-linked packages silently.
            self.onGetStarted = () => {
                return _promiseFactory.defer((promise) => {
                    if (_isNavigating) {
                        promise.resolve({keepSpinning: true});
                        return;
                    }
                    _isNavigating = true;

                    const instruction = _router.activeInstruction();
                    const flowId = instruction.params[0];
                    const queryString = instruction.queryString;

                    _router.navigate(_signupNavigationManager.getFlowStartUrl(flowId, queryString));

                    // The route guards and the plans step's activate() run after this returns and
                    // this view stays mounted for all of it, so hold the spinner rather than
                    // dropping it the moment navigate() is called.
                    promise.resolve({keepSpinning: true});
                });
            };

            self.compositionComplete = () => {
                self.isCompositionComplete(true);
            };

            self.activate = () => {
                _router = require('plugins/router');

                // Constructed but deliberately not init()ed: init seeds the number-type observables
                // from the signup session, and getFlowStartUrl does not read them. The splash sits
                // outside the flow and may be the customer's first page, so it must not fetch - or
                // create - a signup session just to work out where its button goes.
                const SignupNavigationManagerConstructor = require('presentation/signup/common/signupNavigationManager');
                _signupNavigationManager = new SignupNavigationManagerConstructor();

                return _initialize();
            };

            const _initialize = () => {
                return _promiseFactory.wait();
            };
        };
    });

